<template>
  <div>
    <div id="banner">
      <VImg lazy-src="/intro.jpg" src="/intro.jpg" cover height="100%" />
    </div>
    <br />
    <h2 class="text-center">Follow your friends, follow your dreams.</h2>
    <br />
    <div id="features">
      <VRow v-for="item in items" :key="item.icon" class="feature">
        <VCol cols="2">
          <VIcon :icon="item.icon" large />
        </VCol>
        <VCol>
          {{ item.text }}
        </VCol>
      </VRow>
    </div>
    <VRow class="mt-4" justify="center">
      <VCol cols="auto">
        <VBtn color="primary" nuxt to="/sign-up"> Join the community! </VBtn>
      </VCol>
    </VRow>
  </div>
</template>

<script lang="ts" setup>
import {
  mdiMapMarker,
  mdiLock,
  mdiQrcodeScan,
  mdiAccountPlus,
  mdiHeart,
} from '@mdi/js'
import { APP_NAME } from '~/config/app'

const items = [
  {
    icon: mdiMapMarker,
    text:
      APP_NAME +
      ' enables you to share your current or future destinations with old and new friends.',
  },
  {
    icon: mdiLock,
    text: 'You decide what to share with whom and it is important to us, that you are in control at all times!',
  },
  {
    icon: mdiQrcodeScan,
    text: 'Adding a friend is as easy as scanning a QR-Code!',
  },
  {
    icon: mdiAccountPlus,
    text: "Sign up and create your profile now, it's free!",
  },
  {
    icon: mdiHeart,
    text: 'Made by travelers, for travelers!',
  },
]
</script>

<style scoped>
h2 {
  font-size: 1.5rem;
}

#banner {
  max-height: 30vh;
  max-width: 600px;
  margin: auto;
}

#features {
  margin: auto;
  max-width: 600px;
}

.feature {
  margin: 0 1rem 0;
}
</style>
